import { OrganizationProfile } from '@clerk/clerk-react';
import { useAuth } from '../../providers/AuthProvider';
import './organisation.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClerkRolesEnum } from '../../providers/ClerkProvider/types/clerk-roles.enum';
import { PageURL } from '../../router/pageURL';

export const OrganisationProfilePage = () => {
  const { orgRole } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (orgRole?.toLowerCase() === ClerkRolesEnum.Member) {
      navigate(PageURL.ROOT);
    }
  }, [orgRole]);

  return (
    <main className={'flex justify-center mt-8'}>
      <OrganizationProfile
        appearance={{
          elements: {
            userPreviewMainIdentifierText: { overflow: 'unset' },
            userPreviewSecondaryIdentifier: { overflow: 'unset' },
            cardBox: {
              gridTemplateColumns: '1fr 4fr',
              maxWidth: 'unset',
              width: 'unset',
            },
          },
        }}
      />
    </main>
  );
};
